import React from 'react';
import HeaderDropdown from './HeaderDropdown/';
import './Header.scss';

var Header = function Header(_ref) {
  var left = _ref.left,
      right = _ref.right,
      dropdownTitle = _ref.dropdownTitle,
      dropdownElements = _ref.dropdownElements;
  return /*#__PURE__*/React.createElement("div", {
    className: "pwd-header-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pwd-header-left"
  }, left), /*#__PURE__*/React.createElement("div", {
    className: "pwd-header-right"
  }, right), !!(dropdownElements !== null && dropdownElements !== void 0 && dropdownElements.length) && /*#__PURE__*/React.createElement(HeaderDropdown, {
    title: dropdownTitle,
    elements: dropdownElements
  }));
};

export default Header;